import React from 'react';
import './style.scss';
function mobileFooter({ children, ...rest }) {
	return (
		<div className="mobileFooter" {...rest}>
			{children}
		</div>
	);
}
export default mobileFooter;
